/* eslint-disable prettier/prettier */
import { MouseEventHandler, ReactElement } from "react";

const StyledButton = (props: {
  text: string;
  id?: string;
  title?: string;
  className?: string;
  onClick?: MouseEventHandler;
  disabled?: boolean;
  additionalClassName?: string;
}): ReactElement => {
  const coreStyles: string =
    "text-center text-white h-[48px] border-solid border-1 rounded-md bg-[#005DAB]";
  const disabledStyle: string = "bg-gray-650 cursor-not-allowed";
  const activeStyle: string =
    "border-CostcoAction bg-[#005DAB] cursor-pointer";
  const buttonStyles: string = `${coreStyles} ${props.disabled ? disabledStyle : activeStyle
    } ${props.additionalClassName ?? ""} `;
  return (
    <div className="mx-2 block">
      <button
        type="submit"
        id={props.id}
        data-testid={`styled-button-${props.id}`}
        disabled={props.disabled}
        className={`${buttonStyles}${props.className} flex flex-row items-center justify-center`}
        onClick={props.onClick}
        title={props.title}
      >
        <div className="inline-block icon-search text-2xl pr-2" />
        <p>{props.text}</p>
      </button>
    </div>
  );
};
export default StyledButton;
